<template>
  <div>
    <div class="form-item form-add">
      <div class="add-input">
        <span class="form-label"></span>
        <span class="form-input">
          <input
            v-model="inputValue"
            type="text"
            maxlength="1000"
            placeholder
          />
        </span>
        <div class="form-tips">
          <!-- <span class="add" @click="addNewTodo">添加</span> -->
          <span class="remove" v-on:click="$emit('remove')">删除</span>
          <span class="remove" @click="$emit('add')">添加</span>
          <!-- <span class="notice">(请输入涉及的链接)</span> -->
        </div>
      </div>
      <!-- <div class="err">
        {{error}}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HyTodoLink",
  props: {
    value: {
      type: String
    },
    model: {
      prop: "value",
      //这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
      event: "change"
    }
  },
  data() {
    return {
      content: "",
      link: "",
      error: ""
    };
  },
  computed: {
    // 定义一个计算属性,给子组件的 v-model使用
    inputValue: {
      // 计算属性的 get 返回父组件传入的 value,即model,props中定义的 prop
      get() {
        return this.value;
      },
      set(value) {
        //向父组件触发事件,此事件为model中定义的event,子组件v-model绑定了该计算属性,输入时会触发计算属性的set方法,即向父组件触发该事件

        this.$emit("input", value);
      }
    }
  },
  methods: {
    inputChange(e) {
      const val = e.target.value;
      console.log(this.inputValue, e.target.value);
      if (val.indexOf("http://") === 0 || val.indexOf("https://") === 0) {
        this.error = "";
        return;
      }
      this.error = "请输入链接";
    },
    addNewTodo() {
      this.$emit("addNewTodo");
    }
  }
};
</script>

<style lang="scss" scoped>
.remove {
  cursor: pointer;
  display: inline-block;
  margin-right: 16px;
  width: 60px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(151, 151, 151, 1);
  line-height: 28px;
  margin-top: 8px;
  text-align: center;
  color: #000000;
  font-size: 16px;
}
textarea {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(151, 151, 151, 1);
  font-size: 20px;
  box-sizing: border-box;
  padding-left: 8px;
}
textarea {
  width: 554px;
  padding-top: 8px;
  height: 212px;
}
.form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 27px;
  .form-label {
    padding-left: 10px;
    line-height: 40px;
    min-width: 100px;
  }
  .required {
    position: relative;
    &::before {
      content: "*";
      position: absolute;
      color: red;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .form-input {
    display: inline-block;
    input {
      box-sizing: border-box;
      width: 554px;
      line-height: 40px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(151, 151, 151, 1);
      font-size: 20px;
      padding-left: 8px;
      &::-webkit-input-placeholder {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(174, 174, 174, 1);
      }
    }
  }
  .form-upload {
    margin-top: 4px;
  }
  .form-tips {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 105, 105, 1);
    line-height: 21px;
    padding-left: 16px;
    .notice {
      margin-bottom: 17px;
      margin-top: 4px;
      img {
        width: 84px;
        height: 35px;
      }
      .refresh {
        display: inline-block;
        margin-bottom: 10px;
        line-height: 35px;
        vertical-align: top;
        margin-left: 16px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(66, 149, 210, 1);
        cursor: pointer;
      }
    }
    .remain {
      span {
        font-size: 20px;
      }
    }
    .add {
      cursor: pointer;
      display: inline-block;
      margin-right: 16px;
      width: 60px;
      height: 28px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(151, 151, 151, 1);
      line-height: 28px;
      margin-top: 8px;
      text-align: center;
      color: #000000;
      font-size: 16px;
    }
  }
}
.form-add {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  .add-input {
    display: flex;
  }
}
.err {
  color: red;
  margin: 10px 0 -20px 110px;
}
</style>
